import { getReporter } from './reporter'

/**
 * 采集页面加载各阶段耗时
 *
 * 使用 Navigation Timing API 获取 DNS/TCP/SSL/TTFB/下载/DOM 解析等细分数据，
 * 仅在页面首次加载时采集一次
 */
export function setupPageLoad(): void {
  if (typeof window === 'undefined') return

  const collect = () => {
    const reporter = getReporter()
    if (!reporter) return

    const nav = performance
      .getEntriesByType('navigation')
      .find(
        (entry): entry is PerformanceNavigationTiming =>
          entry instanceof PerformanceNavigationTiming
      )
    if (!nav) return
    const ssl = nav.secureConnectionStart > 0 ? nav.connectEnd - nav.secureConnectionStart : 0

    reporter.addPageLoad({
      dns: nav.domainLookupEnd - nav.domainLookupStart,
      tcp: nav.connectEnd - nav.connectStart,
      ssl,
      ttfb: nav.responseStart - nav.requestStart,
      download: nav.responseEnd - nav.responseStart,
      domParse: nav.domInteractive - nav.responseEnd,
      domReady: nav.domContentLoadedEventEnd - nav.startTime,
      fullLoad: nav.loadEventEnd - nav.startTime,
      whiteScreen: nav.responseStart - nav.startTime,
      timestamp: Date.now(),
    })
  }

  if (document.readyState === 'complete') {
    setTimeout(collect, 0)
  } else {
    window.addEventListener('load', () => setTimeout(collect, 0))
  }
}
